import Image from 'next/image'
import Link from 'next/link'
import { cn } from '@/lib/utils'

export function Logo({
  className,
  showWordmark = true,
  href = '/',
}: {
  className?: string
  showWordmark?: boolean
  href?: string
}) {
  return (
    <Link
      href={href}
      className={cn('group inline-flex items-center gap-2.5', className)}
      aria-label="Rombex home"
    >
      <span className="relative block h-8 w-8 shrink-0">
        <Image
          src="/rombex-logo.png"
          alt="Rombex logo"
          fill
          sizes="32px"
          className="object-contain"
          priority
        />
      </span>
      {showWordmark && (
        <span className="text-lg font-semibold tracking-tight text-foreground">Rombex</span>
      )}
    </Link>
  )
}
